import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { IWorkplaceGroup } from '@api/types'
import { WorkplaceGroupFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  addSpacesToWorkplaceGroup: {
    workplaceGroup: IWorkplaceGroup
  }
}

const mutation = gql`
  mutation AddSpacesToWorkplaceGroup($input: AddSpacesToWorkplaceGroupInput!) {
    addSpacesToWorkplaceGroup(input: $input) {
      workplaceGroup {
        ...WorkplaceGroupFragment
      }
    }
  }
  ${WorkplaceGroupFragment}
`

const mutateHandler = handleFetchResult<IPayload, IWorkplaceGroup>({
  handler: (data) => data.addSpacesToWorkplaceGroup.workplaceGroup,
  name: 'Spaces',
})

export default async function addSpacesToWorkplaceGroup(
  workplaceGroupId: string | undefined,
  spaceIds: string[]
): Promise<IWorkplaceGroup> {
  const input = { spaceIds, workplaceGroupId }

  try {
    return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
  } catch (e: any) {
    return e
  }
}
